import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  dark: boolean;
  setDark: (v: boolean) => void;
  toggleDark: () => void;
}

/** 다크/라이트 모드 — 사용자 환경설정으로 localStorage 에 영속화. */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      dark: false,
      setDark: (v) => set({ dark: v }),
      toggleDark: () => set((s) => ({ dark: !s.dark })),
    }),
    { name: 'grovision-admin-theme' },
  ),
);
